<template>
  <a-upload
    :showUploadList="false"
    accept=".srt,.vtt"
    :customRequest="handleChangeEn"
  >
    <a-button type="primary" :loading="uploadLoading" v-if="customType == 1 ? customInfo.subtitleCn :
    customType == 2 ? customInfo.subtitle :
    customType == 3 ? customInfo.subtitleEn : customType == 4 ? customInfo.subtitleBm : customInfo.subtitleIn">{{ $t('gather.replace') }}</a-button>
    <a-button :loading="uploadLoading" v-else> <a-icon type="upload" /> {{ $t('gather.upload') }} </a-button>
  </a-upload>
</template>

<script>
import {updateGather} from "@/api/video/gather";
import { uploadOss, ensureHttpsUrl } from '@/api/tool/oss'
import { getSTSToken } from '@/api/tool/common'
import COS from 'cos-js-sdk-v5'

export default {
  name: "gatherUploadBtn",
  props:{
    customInfo:{
      type:Object,
    },
    customIndex:{
      type:Number
    },
    customType:{
      type:Number
    }
  },
  data() {
    return {
      uploadLoading: false
    }
  },
  methods:{
    /**
     * 字幕文件上传方法
     * 使用 /common/oss 接口获取临时凭证，然后直接上传到腾讯云COS
     */
    async handleChangeEn(info) {
      console.log('handleChangeEn 被调用', info)
      const that = this
      
      // 1. 文件类型验证
      var fileType = info.file.name;
      if (fileType.indexOf('vtt') < 0 && fileType.indexOf('srt') < 0) {
        that.uploadLoading = false
        that.$message.warning(that.$t('gather.uploadVttFile'));
        if (info.onError) {
          info.onError(new Error(that.$t('gather.invalidFileType')))
        }
        return
      }
      
      // 2. 设置 loading 状态
      that.uploadLoading = true
      
      // 3. 立即通知上传开始
      if (info.onProgress) {
        info.onProgress({ percent: 0 })
      }
      
      const fieldMap = {
        1: { field: 'subtitleCn', prefix: 'subtitle/cn' },
        2: { field: 'subtitle', prefix: 'subtitle/zh' },
        3: { field: 'subtitleEn', prefix: 'subtitle/en' },
        4: { field: 'subtitleBm', prefix: 'subtitle/bm' },
        5: { field: 'subtitleIn', prefix: 'subtitle/in' }
      }
      
      const config = fieldMap[this.customType]
      if (!config) {
        that.uploadLoading = false
        that.$message.error(that.$t('gather.unknownSubtitleType'))
        if (info.onError) {
          info.onError(new Error(that.$t('gather.unknownSubtitleType')))
        }
        return
      }

      try {
        console.log('开始上传，字幕类型:', this.customType, '配置:', config)
        // 1. 生成文件路径
        const filePath = uploadOss(info.file.name, config.prefix)
        console.log('生成的文件路径:', filePath)

        // 2. 先获取 bucket 和 region 信息
        console.log('获取临时凭证（/common/oss 接口）...')
        const stsToken = await getSTSToken()
        console.log('获取到的临时凭证:', stsToken)
        if (!stsToken || !stsToken.data) {
          throw new Error(that.$t('gather.cosCredentialFailed'))
        }

        const bucket = stsToken.data.bucket
        const region = stsToken.data.region
        console.log('Bucket:', bucket, 'Region:', region)

        // 3. 使用 getAuthorization 回调方式，动态获取临时凭证
        // getSTSToken() 内部调用 /common/oss 接口（POST方法）
        const cos = new COS({
          getAuthorization: async function(options, callback) {
            try {
              console.log('getAuthorization 回调被调用')
              const token = await getSTSToken() // 调用 /common/oss 接口
              if (!token || !token.data) {
                callback(that.$t('gather.cosCredentialFailed'))
                return
              }

              const startTime = Math.floor(Date.now() / 1000)
              const expiredTime = startTime + 1800

              callback({
                TmpSecretId: token.data.accessKeyId,
                TmpSecretKey: token.data.accessKeySecret,
                XCosSecurityToken: token.data.securityToken,
                ExpiredTime: expiredTime,
                StartTime: startTime
              })
            } catch (error) {
              console.error('getAuthorization 错误:', error)
              callback(error.message || that.$t('gather.cosCredentialFailed'))
            }
          },
          Protocol: 'https:',
          Timeout: 60000,
          UseAccelerate: false,
          CorrectClockSkew: true
        })

        // 4. 判断文件大小，选择上传方式
        const fileSize = info.file.size
        const isLargeFile = fileSize > 5 * 1024 * 1024 // 5MB
        console.log('文件大小:', fileSize, '是否大文件:', isLargeFile)

        let uploadResult
        if (isLargeFile) {
          console.log('使用分片上传')
          uploadResult = await cos.uploadFile({
            Bucket: bucket,
            Region: region,
            Key: filePath,
            Body: info.file,
            SliceSize: 1024 * 1024 * 5,
            ContentType: info.file.type || 'application/octet-stream',
            onProgress: function(progressData) {
              console.log('上传进度:', progressData)
              if (info.onProgress) {
                info.onProgress(progressData)
              }
            }
          })
        } else {
          console.log('使用简单上传')
          uploadResult = await cos.putObject({
            Bucket: bucket,
            Region: region,
            Key: filePath,
            Body: info.file,
            ContentType: info.file.type || 'application/octet-stream',
            onProgress: function(progressData) {
              console.log('上传进度:', progressData)
              if (info.onProgress) {
                info.onProgress(progressData)
              }
            }
          })
        }
        console.log('上传结果:', uploadResult)

        // 5. 检查上传结果并构建 URL
        if (uploadResult && (uploadResult.statusCode === 200 || uploadResult.ETag || uploadResult.Location)) {
          let url = ''
          if (stsToken.data.staticUrl) {
            url = stsToken.data.staticUrl + (stsToken.data.staticUrl.endsWith('/') ? '' : '/') + filePath
          } else if (uploadResult.Location) {
            url = uploadResult.Location
          } else {
            url = `https://${bucket}.cos.${region}.myqcloud.com/${filePath}`
          }
          // 确保 URL 包含 https:// 前缀
          url = ensureHttpsUrl(url)

          // 6. 更新对应的字幕字段
          that.customInfo[config.field] = url
          that.uploadLoading = false

          // 7. 保存到后端
          updateGather(that.customInfo).then(res => {
            that.$emit("change")
            that.$message.success(that.$t('gather.uploadSuccess'))
            if (info.onSuccess) {
              info.onSuccess({ url }, info.file)
            }
          }).catch(error => {
            that.$message.error(that.$t('gather.saveFailed'))
            if (info.onError) {
              info.onError(error)
            }
          })
        } else {
          throw new Error(that.$t('gather.uploadFailed'))
        }
      } catch (error) {
        console.error('上传失败:', error)
        that.uploadLoading = false
        const errorMessage = error.message || that.$t('gather.uploadFailed')
        that.$message.error(errorMessage)
        if (info.onError) {
          info.onError(error)
        }
      }
    },
  }
}
</script>

<style scoped>

</style>